import { message } from '../../utils/message';
import { HtmlParser } from '../html-parser';
type MessageProps = {
  text: unknown;
  fallback: string;
  variables?: Record<string, string | number>;
};

export function Message(props: MessageProps): JSX.Element {
  return (
    <HtmlParser html={message(props.text, props.fallback, props.variables)} />
  );
}
